module.exports = __webpack_public_path__ + "media/3.69a7e74e.mp4";